import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"mouse-classic-2, click"} maskId="square-filled-radius-0-stroke-1-IconMouseClassic2"><path d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5.00001 18.866 5 15V10H19V15Z" fill="currentColor"/><path d="M11.5 9H5V2H11.5V9Z" fill="currentColor"/><path d="M19 9H12.5V2H19V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMouseClassic2;
